import React from 'react';
import {
  DateInput,
  FormLabel,
  ModalBody,
  SearchSelect,
  VStack,
  FormControl,
} from '@wegroup/design-system';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AccidentLiabilty, AccidentType } from '../../../../types/Accident';
import { sortBy } from 'lodash';

const AccidentEditModalBody: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const typeOptions = Object.keys(AccidentType).map((key) => ({
    label: t(`ACCIDENT_LIABILITY_${key}`),
    value: key,
  }));
  const liabilityOptions = Object.keys(AccidentLiabilty).map((key) => ({
    label: t(`ACCIDENT_TYPE_${key}`),
    value: key,
  }));

  return (
    <ModalBody>
      <VStack align="stretch" spacing="3" data-test-id="ProdFac_AccidentForm">
        <FormControl>
          <FormLabel>{t('Date of the accident')}*</FormLabel>
          <Controller
            name="date"
            control={control}
            render={({
              field: { onChange, value, name },
              fieldState: { error },
            }) => (
              <DateInput
                name={name}
                error={error?.message}
                onChange={({ value }: { value: string }) => onChange(value)}
                value={value}
                data-test-id="ProdFac_AccidentForm_AccidentDate"
              />
            )}
          />
        </FormControl>
        <FormControl>
          <FormLabel>{t('ACCIDENT_LIABILITY_TITLE')}*</FormLabel>
          <Controller
            name="liability"
            control={control}
            render={({ field: { onChange, value }, fieldState }) => (
              <SearchSelect
                clearable
                placeholder={t('DEFAULT_SELECT_PLACEHOLDER')}
                data={sortBy(liabilityOptions, 'label')}
                error={
                  fieldState.error?.message
                    ? t(fieldState.error?.message)
                    : undefined
                }
                data-test-id={`FLOWS_ACCIDENT-INPUT_SELECT-TYPE`}
                value={value}
                onChange={onChange}
              />
            )}
          />
        </FormControl>
        <FormControl>
          <FormLabel>{t('Type')}</FormLabel>
          <Controller
            name="type"
            control={control}
            render={({ field: { onChange, value }, fieldState }) => (
              <SearchSelect
                clearable
                placeholder={t('DEFAULT_SELECT_PLACEHOLDER')}
                data={sortBy(typeOptions, 'label')}
                error={
                  fieldState.error?.message
                    ? t(fieldState.error?.message)
                    : undefined
                }
                data-test-id={`FLOWS_ACCIDENT-INPUT_SELECT-TYPE`}
                value={value}
                onChange={onChange}
              />
            )}
          />
        </FormControl>
      </VStack>
    </ModalBody>
  );
};

export default AccidentEditModalBody;
